import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe  from 'photoswipe'

/**
 * Class HTML элемента.
 */
const galleryElementSingle = 'ps-gallery-single'


/**
 * Initializes a PhotoSwipe lightbox for the ps gallery.
 *
 * Здесь может быть любая необходимая логика.
 *
 * Экспорт функции инициализации дает возможность
 * контроля, когда и как подключать.
 *
 * @returns {PhotoSwipeLightbox | null} The created lightbox instance, or null if not initialized.
 */
export function createPsGalleryElementSingle(): PhotoSwipeLightbox | null {
  if (typeof document === 'undefined') return null

  const gallery = new PhotoSwipeLightbox({
    gallery: `.${galleryElementSingle}`,
    children: 'a',
    pswpModule: PhotoSwipe,
  })

  gallery.init()
  return gallery
}
